var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAustraliaIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 150.157,
    height: 67.589,
    viewBox: "0 0 150.157 67.589",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_19990",
    "data-name": "Group 19990",
    transform: "translate(-775.65 -554.566)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19969",
    "data-name": "Group 19969",
    transform: "translate(-116.804 346.722)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19967",
    "data-name": "Group 19967"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20806",
    "data-name": "Path 20806",
    d: "M955.954,272.052l-53.687-.009s13.481-14.8,29.385-18.414",
    fill: "#fff",
    stroke: "#002173",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20807",
    "data-name": "Path 20807",
    d: "M940.413,256.777,905.05,273.912,892.8,230.873S929.728,227.692,940.413,256.777Z",
    fill: "#fff",
    stroke: "#002173",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20808",
    "data-name": "Path 20808",
    d: "M957.086,252.966l-40.121,16.546-10.649-48.258S947.233,220.194,957.086,252.966Z",
    fill: "#fff",
    stroke: "#002173",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20809",
    "data-name": "Path 20809",
    d: "M982.348,252.705l-52,17.307-9.161-61.734S972.825,210.55,982.348,252.705Z",
    fill: "#fff",
    stroke: "#002173",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20810",
    "data-name": "Path 20810",
    d: "M960.954,275.052l-54.472-5.131s18.3-12.412,36.307-12.189",
    fill: "#fff",
    stroke: "#002173",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20811",
    "data-name": "Path 20811",
    d: "M968.787,239.718l34.667,28.667,24.666-45.333S988.12,209.718,968.787,239.718Z",
    fill: "#fff",
    stroke: "#002173",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20812",
    "data-name": "Path 20812",
    d: "M927.787,272.385s13.908-24.21,34.48-33.917a17.409,17.409,0,0,1,16.287.875c9.513,5.637,25.526,17.2,31.9,34.042Z",
    fill: "#fff",
    stroke: "#002173",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20813",
    "data-name": "Path 20813",
    d: "M1006.848,255.362,988.23,270.757l-13.247-24.346S996.465,239.25,1006.848,255.362Z",
    fill: "#fff",
    stroke: "#002173",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20814",
    "data-name": "Path 20814",
    d: "M1000.22,254.709l25.078,19.408,16.822-31.951S1013.492,233.518,1000.22,254.709Z",
    fill: "#fff",
    stroke: "#002173",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20815",
    "data-name": "Path 20815",
    d: "M961.787,269.385c7.333-31.4,9.167-32.167,9.167-32.167l-6.815,32.167",
    fill: "#fff",
    stroke: "#002173",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20816",
    "data-name": "Path 20816",
    d: "M981.1,268.911s6.789-11.818,16.83-16.555a8.5,8.5,0,0,1,7.95.427c4.644,2.751,12.46,8.393,15.571,16.616Z",
    fill: "#fff",
    stroke: "#002173",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20817",
    "data-name": "Path 20817",
    d: "M1002.173,251.746s-4.173,5.03-4.474,17.306",
    fill: "#fff",
    stroke: "#002173",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20818",
    "data-name": "Path 20818",
    d: "M1029.454,275.052h-124a3.009,3.009,0,0,1-3-3h0a3.009,3.009,0,0,1,3-3h124a3.009,3.009,0,0,1,3,3h0A3.009,3.009,0,0,1,1029.454,275.052Z",
    fill: "#fff",
    stroke: "#002173",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20819",
    "data-name": "Path 20819",
    d: "M927.12,213.052s25.667,5.333,38.334,20.333",
    fill: "#fff",
    stroke: "#002173",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20820",
    "data-name": "Path 20820",
    d: "M978.12,235.385s18-17.667,43-10",
    fill: "#fff",
    stroke: "#002173",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19968",
    "data-name": "Group 19968"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12508",
    "data-name": "Rectangle 12508",
    width: 2.985,
    height: 2.985,
    transform: "translate(943.287 271.54)",
    fill: "#0f2867"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12509",
    "data-name": "Rectangle 12509",
    width: 2.985,
    height: 2.985,
    transform: "translate(950.772 271.54)",
    fill: "#0f2867"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12510",
    "data-name": "Rectangle 12510",
    width: 2.985,
    height: 2.985,
    transform: "translate(958.257 271.54)",
    fill: "#0f2867"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12511",
    "data-name": "Rectangle 12511",
    width: 2.985,
    height: 2.985,
    transform: "translate(965.743 271.54)",
    fill: "#0f2867"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12512",
    "data-name": "Rectangle 12512",
    width: 2.985,
    height: 2.985,
    transform: "translate(973.228 271.54)",
    fill: "#0f2867"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12513",
    "data-name": "Rectangle 12513",
    width: 2.985,
    height: 2.985,
    transform: "translate(980.713 271.54)",
    fill: "#0f2867"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12514",
    "data-name": "Rectangle 12514",
    width: 2.985,
    height: 2.985,
    transform: "translate(988.198 271.54)",
    fill: "#0f2867"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_2029",
    "data-name": "Line 2029",
    x2: 129.401,
    transform: "translate(902.753 271.54)",
    fill: "#fff",
    stroke: "#002173",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20821",
    "data-name": "Path 20821",
    d: "M965.028,265.187l11.556-6.761,7.938,5.517",
    fill: "none",
    stroke: "#002173",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20822",
    "data-name": "Path 20822",
    d: "M930.89,269.052l17.2-12.375,14.317,8.514",
    fill: "none",
    stroke: "#002173",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20823",
    "data-name": "Path 20823",
    d: "M927.12,252.341l-10.512-.775,1.1,11.778",
    fill: "none",
    stroke: "#002173",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20824",
    "data-name": "Path 20824",
    d: "M915.79,264.187l-11.443-1.347v6.427",
    fill: "#fff",
    stroke: "#002173",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2030",
    "data-name": "Line 2030",
    x1: 21.273,
    y2: 24.19,
    transform: "translate(1006.848 223.052)",
    fill: "#fff",
    stroke: "#002173",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2031",
    "data-name": "Line 2031",
    y1: 26.886,
    x2: 20.803,
    transform: "translate(1021.318 242.166)",
    fill: "#fff",
    stroke: "#002173",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2032",
    "data-name": "Line 2032",
    x2: 14.598,
    y2: 49.956,
    transform: "translate(921.185 208.278)",
    fill: "#fff",
    stroke: "#002173",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20825",
    "data-name": "Path 20825",
    d: "M999.031,269.052l1.19-6.211h15.691l3.683,6.211",
    fill: "#fff",
    stroke: "#002173",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.7
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAustraliaIcon);
export default __webpack_public_path__ + "static/media/australia_icon.7b6be9e5b84727fb1cf418b8538cac95.svg";
export { ForwardRef as ReactComponent };